import { Navigate, useLocation, useNavigate } from "react-router-dom";

import ProfileWizard from "../components/ProfileWizard";
import { storage } from "../lib/storage";

type OnboardingRouteState = {
  fromLine?: boolean;
  lineCompletionTarget?: "home" | "lineComplete";
  returnTo?: string;
};

function resolveNextPath(routeState: OnboardingRouteState): string {
  if (routeState.returnTo && routeState.returnTo !== "/onboarding") {
    return routeState.returnTo;
  }

  if (routeState.fromLine && routeState.lineCompletionTarget !== "home") {
    return "/line-register/complete";
  }

  return "/home";
}

export default function EmailInviteOnboarding() {
  const navigate = useNavigate();
  const location = useLocation();
  const routeState =
    (typeof location.state === "object" && location.state ? location.state : {}) as OnboardingRouteState;

  const auth = storage.getAuth();
  if (!auth.userId && !auth.accessToken && !auth.refreshToken && !auth.secretKey) {
    return <Navigate to="/splash" replace />;
  }

  const handleComplete = () => {
    navigate(resolveNextPath(routeState), { replace: true });
  };

  return <ProfileWizard mode="onboarding" onComplete={handleComplete} />;
}
